import { gql } from "apollo-boost"

export const DELETE_ACTIVITY_SCHEDULE = gql`
  mutation deleteSchedule($scheduleIds: [ID!]!) {
    DeleteActivitySchedulesByIDs(scheduleIds: $scheduleIds) 
  }
`